import validate from "/var/www/mysite/node_modules/nuxt/dist/pages/runtime/validate.js";
import _00_45auth_45global from "/var/www/mysite/app/middleware/00.auth.global.ts";
import auth_45global from "/var/www/mysite/app/middleware/auth.global.ts";
import routing_45global from "/var/www/mysite/app/middleware/routing.global.ts";
import manifest_45route_45rule from "/var/www/mysite/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  _00_45auth_45global,
  auth_45global,
  routing_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}